import(/* webpackMode: "eager" */ "/vercel/path0/app/projets/page.jsx")